import React, {useEffect, useState} from 'react'
import {BASE_URL} from '../../config'
import usePaginationCounts from '../../../utils/hooks/usePaginationCounts'
import {IArticleList, IArticleParams} from '../core/_model'
import {useQuery} from 'react-query'
import axios from 'axios'
import {handleAxiosError, searchItems} from '../../../utils/helperFunction/_helper'
import {ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import TableContentHeader from '../../../utils/components/table-content/TableContentHeader'
import TableContent from '../../../utils/components/table-content/TableContent'
import TablePagination from '../../../utils/components/table-content/TablePagination'
import articleColumn from './articleColumn'
import toast from 'react-hot-toast'
// import articleColumn from './ArticleColumn'

const GET_ARTICLE_LIST_URL = `${BASE_URL}/api/protect/getAllKnowledgeWithPage`
const GET_ARTICLE_LIST_BY_ID = `${BASE_URL}/api/protect/getKnoledgeById`

type Props = {
  searchTerm: string
  selectedArticle: (id: IArticleList) => void
  selectedCategoryId: number | null
}

const ArticleList = ({searchTerm, selectedArticle, selectedCategoryId}: Props) => {
  const {
    pagination: {totalElement, page, size},
    updatePagination,
    handlePageChange,
    handlePagePerItem,
  } = usePaginationCounts(1, 10)

  const [articlesList, setArticlesList] = useState<IArticleList[]>([])

  const {data, isLoading, error} = useQuery({
    queryKey: ['article', {page, size, selectedCategoryId}],
    queryFn: async () => {
      let param: Partial<IArticleParams> = {
        page,
        size,
      }

      if (selectedCategoryId) {
        param = {
          ...param,
          category: selectedCategoryId,
        }
      }
      const response = await axios.get(GET_ARTICLE_LIST_URL, {params: param})
      console.log(response)
      const data = await response.data

      return {
        list: data.data,
        pagination: data.pagenationResponse,
      }
    },
    onError: (error: Error) => {
      console.log(error)
    },
  })

  const handleSelect = async (id: number) => {
    toast.loading('Processing..')
    try {
      const response = await axios.get(`${GET_ARTICLE_LIST_BY_ID}/${id}`)
      const data = await response.data
      selectedArticle(data)
      toast.dismiss()
    } catch (error) {
      console.log(error)
      toast.dismiss()
      const message = handleAxiosError(error)
      toast.error(message)
    }
  }

  useEffect(() => {
    if (data) {
      const keys: (keyof IArticleList)[] = ['title', 'description', 'category_name', 'user_name']
      const filtered = searchItems(data.list, searchTerm, keys)
      setArticlesList(filtered || [])
      updatePagination(data.pagination)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, data])

  return (
    <ListViewProvider isLoading={isLoading} data={articlesList}>
      <TableContentHeader size={size} handlePagePerItem={handlePagePerItem} />

      <TableContent
        isLoading={isLoading}
        error={error}
        tableData={articlesList}
        tableColumn={articleColumn(handleSelect)}
      >
        {isLoading && !data ? (
          <div className='d-flex justify-content-center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          <TablePagination
            totalElement={totalElement}
            isLoading={isLoading}
            itemsPerPage={size}
            currentPage={page}
            handlePageChange={handlePageChange}
          />
        )}
      </TableContent>
    </ListViewProvider>
  )
}

export default ArticleList
